  <template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="extra-large"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("assign_trainings_to_user") }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <certificate-users v-if="type == 'issue-certificate-to-user'" :certificate_id="certificateId"></certificate-users>
      <user-training-listing :userId="user_id" v-else></user-training-listing>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <!-- <button
        type="submit"
        class="btn btn-primary mr-2"
        @click.prevent="submitData"
      >
        {{ $t("submit") }}
      </button> -->
    </template>
  </app-modal>
</template>

<script>
import {ModalMixin} from "../../../../app/Mixins/ModalMixin";
import {FormMixin} from "../../../../core/mixins/form/FormMixin.js";
import {ROLES, USERS} from "../../../Config/ApiUrl";

import UserTrainingListing from "@Views/UserTrainings/UserTrainingList";

export default {
  name: "UserTrainingList",
  mixins: [ModalMixin, FormMixin],
  props: {
    user_id: {type: Number, default: null},
    type: {type: String, default:''},
    certificateId: {type: Number, default: null},
  },
  components:{UserTrainingListing},
  data() {
    return {
      modalId: "useraddmodal",
      // inputs: {
      //   email: ' ',
      //   password: ' ',
      // },
      // roleLists: [],
    };
  },
  methods: {
    // submitData() {
    //   if (this.inputs.date)
    //       this.inputs.date = this.getDateFormatForBackend(this.inputs.date);
    //       this.inputs.company_id = this.userRole.company_id;
    //   // axiosPost(USERS, this.inputs)
    //   //   .then((res) => {
    //   //     this.$toastr.s(res.data.message);
    //   //     this.$hub.$emit("reload-" + this.tableId);
    //   //   })
    //   //   .catch((error) => {
    //   //     this.$toastr.e(error.message);

    //   //   })
    //   //   .finally(() => {
    //   //     $("#useraddmodal").modal("hide");
    //   //     this.reLoadTable();
    //   //     this.preloader = false;
    //   //   });
    //   this.save(this.inputs);
    // },
    // afterSuccess(response) {
    //   this.$toastr.s(response.data.message);
    //   this.$hub.$emit("reload-" + this.tableId);
    // },
    // getRoles() {
    //   this.preloader = this.hasData ? true : false;

    //   this.axiosGet(ROLES)
    //     .then((response) => {
    //       this.roleLists = response.data.data;
    //     })
    //     .catch(({ response }) => {})
    //     .finally(() => {
    //       this.preloader = false;
    //     });
    // },
  },
  mounted() {
    // this.getRoles();
  },
  // computed: {
  //   userRole() {
  //     return this.$store.state.user.loggedInUser;
  //   },
  // },
};
</script>
